import { useState } from "react";
import ReactSelect from "react-tailwindcss-select";
import "./styles.css";
import { getIn } from "formik";
import { useTranslation } from "react-i18next";

const Select = ({
  options,
  formik,
  name,
  onChange,
  label,
  placeholder,
  onSearch,
  menuClassName,
  showError,
  disabled,
}) => {
  const [value, setValue] = useState(null);
  const handleSelect = (val) => {
    setValue(val);
    formik?.setFieldValue(name, val.value);
    formik?.setFieldTouched(name, true);
    if (!onChange) return;
    onChange(val);
  };

  const required =
    formik && Object.keys(formik?.initialValues).some((key) => key === name);
  const nestedError = getIn(formik?.errors, name);
  const nestedTouched = getIn(formik?.touched, name);
  const { t } = useTranslation();
  return (
    <div className="relative w-full">
      {label && (
        <label className="block mb-1 font-semibold capitalize text-primary">
          {label} {required && <span className="text-mainRed">*</span>}
        </label>
      )}
      <ReactSelect
        value={value}
        options={options || []}
        placeholder={placeholder || t("select")}
        onSearchInputChange={onSearch}
        onChange={handleSelect}
        classNames={{
          menuButton: ({ isDisabled }) =>
            `flex text-sm text-mainGray items-center select-menu h-[56px] px-2 border border-[#88888880] rounded-[12px] shadow-sm transition-all duration-300 focus:outline-none  ${
              isDisabled
                ? "bg-gray-200"
                : "bg-sideBar hover:border-gray-400 border-primary  focus:border-blue-500 focus:ring focus:ring-blue-500/20"
            } ${menuClassName}`,
          listItem: ({ isSelected }) =>
            `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate  ${
              isSelected
                ? `text-white bg-sideBar`
                : `text-gray-400 hover:bg-blue-950 hover:text-blue-500`
            }`,
          menu: "absolute z-10 w-full bg-mainBg shadow-lg border rounded  mt-1.5 text-sm text-gray-700",
        }}
      />
      {(showError || !disabled) && nestedError && (showError || nestedTouched) && (
        <span className="text-[12px] text-mainRed absolute bottom-[-18px]">
          {nestedError}
        </span>
      )}
    </div>
  );
};

export default Select;
